import { exportStock } from "@/services/api/StockServiceApi";
import { downloadExcelBase64 } from "./fileDownloadHelper";

export async function handleExportStock(filename, ids = []) {
    try {
        const response = await exportStock(ids);

        if (response.status === 200 && response.data?.payload?.length > 0) {
            const base64 = response.data.payload[0]?.base64;
            downloadExcelBase64(base64, filename);
            return { success: true };
        }
        throw new Error(
            Array.isArray(response.data?.messages)
                ? response.data.messages.join(', ')
                : ''
        );
    } catch (err) {
        return {
            success: false,
            message: err?.message || 'Erro inesperado ao exportar dados',
        };
    }
}